module.exports = __webpack_public_path__ + "img/zoom-in-orange.c79edaeb.svg";